module.exports = __webpack_public_path__ + "media/images/shared/suppliers/COJALI-b902a56b99379b798232ea13d673f1c0.jpg";